import React from "react";
import { PanelHeader } from "./ScenarioPanel";
import { CheckCircle, Users, ArrowSquareOut, Clock, FileText } from "@phosphor-icons/react";

export const OutcomePanel = ({ outcome }) => {
  if (!outcome) return null;
  const { action, partiesNotified, handoff, receipt, auditTrail } = outcome;

  return (
    <section
      data-testid="outcome-panel"
      className="panel-in w-[340px] shrink-0 h-full flex flex-col bg-white border border-stone-200 rounded-sm"
    >
      <PanelHeader layer="outcome" title="Outcome & Evidence" subtitle="What actually happened" />

      <div className="flex-1 overflow-y-auto p-4 flex flex-col gap-4 scroll-soft">
        <div className="border border-stone-200 rounded-sm p-3 bg-stone-50/40">
          <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-stone-500">
            <CheckCircle size={12} /> Action taken
          </div>
          <p className="text-sm text-stone-900 mt-1 leading-relaxed">{action}</p>
        </div>

        <div>
          <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-stone-500 mb-1.5">
            <Users size={12} /> Parties notified
          </div>
          <div className="flex flex-wrap gap-1">
            {partiesNotified.map((p) => (
              <span key={p} className="text-[11px] px-1.5 py-0.5 bg-stone-100 text-stone-700 rounded-sm">
                {p}
              </span>
            ))}
          </div>
        </div>

        <div className="border border-stone-200 rounded-sm p-3">
          <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-stone-500">
            <ArrowSquareOut size={12} /> Operational handoff
          </div>
          <div className="text-sm text-stone-900 mt-1">
            {handoff.occurred ? handoff.to : "—"}
          </div>
          <div className="text-xs text-stone-500 mt-0.5">{handoff.note}</div>
        </div>

        <div className="border border-stone-200 rounded-sm p-3 bg-white">
          <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-stone-500">
            <FileText size={12} /> Receipt summary
          </div>
          <dl className="font-mono text-[11px] text-stone-700 mt-2 space-y-0.5">
            <RR k="id" v={receipt.id} />
            <RR k="route" v={receipt.modelRoute} />
            <RR k="cost/1k" v={`$${receipt.cost.toFixed(4)}`} />
            <RR k="latency" v={`${receipt.latency_ms}ms`} />
            <RR k="status" v={receipt.status} />
          </dl>
        </div>

        <div>
          <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-stone-500 mb-1.5">
            <Clock size={12} /> Event log
          </div>
          <ol className="space-y-2">
            {auditTrail.map((e, i) => (
              <li key={i} className="flex gap-2">
                <div className="flex flex-col items-center">
                  <div className="w-1.5 h-1.5 bg-stone-700 rounded-full mt-1" />
                  {i < auditTrail.length - 1 && (
                    <div className="w-px flex-1 bg-stone-200 mt-0.5" />
                  )}
                </div>
                <div className="flex-1 pb-1">
                  <div className="text-[11px] font-medium text-stone-900">{e.label}</div>
                  <div className="text-[11px] text-stone-500 leading-relaxed">{e.detail}</div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

const RR = ({ k, v }) => (
  <div className="flex gap-3">
    <span className="text-stone-400 w-14 shrink-0">{k}</span>
    <span className="text-stone-800 flex-1 break-words">{v}</span>
  </div>
);
